/**
 * Map Firebase auth error codes to user-friendly messages.
 */
export function mapAuthError(code: string): string {
  const errorMap: Record<string, string> = {
    'auth/invalid-credential': 'Invalid email or password. Please try again.',
    'auth/user-not-found': 'No account found with this email.',
    'auth/wrong-password': 'Incorrect password. Please try again.',
    'auth/too-many-requests': 'Too many failed attempts. Please try again later.',
    'auth/network-request-failed': 'Network error. Please check your connection.',
    'auth/invalid-email': 'Please enter a valid email address.',
    'auth/user-disabled': 'This account has been disabled. Contact support.',
  };

  return errorMap[code] || 'An error occurred during sign in. Please try again.';
}
